import { defineStore } from 'pinia'

// This store is used for app-wide ui settings such as the main app banner
export const useAppStore = defineStore('app', () => {
/*
  ███████ ████████  █████  ████████ ███████
  ██         ██    ██   ██    ██    ██
  ███████    ██    ███████    ██    █████
       ██    ██    ██   ██    ██    ██
  ███████    ██    ██   ██    ██    ███████
  STATE
*/
  const defaultBanner = () => ({
    title: '',
    msg: '',
    href: '',
    linkText: '',
    show: false,
    type: 'info',
    label: '',
  })

  const mainBanner = ref(defaultBanner())

/*
   ██████  ███████ ████████ ████████ ███████ ██████  ███████
  ██       ██         ██       ██    ██      ██   ██ ██
  ██   ███ █████      ██       ██    █████   ██████  ███████
  ██    ██ ██         ██       ██    ██      ██   ██      ██
   ██████  ███████    ██       ██    ███████ ██   ██ ███████
  GETTERS
*/


/*
   █████   ██████ ████████ ██  ██████  ███    ██ ███████
  ██   ██ ██         ██    ██ ██    ██ ████   ██ ██
  ███████ ██         ██    ██ ██    ██ ██ ██  ██ ███████
  ██   ██ ██         ██    ██ ██    ██ ██  ██ ██      ██
  ██   ██  ██████    ██    ██  ██████  ██   ████ ███████
  ACTIONS
  ! - - Actions calling other actions in the same store must use `this.actionName(...)`
  ! - - If we do not use `this.actionName` it will not be properly mockable in tests.
  ! - - Computeds and refs will work fine, and should be called directly though.
*/

  const addBanner = ({title, msg, href, linkText, type = 'info', label = ''} = {}) => {
    mainBanner.value.msg = msg
    mainBanner.value.title = title
    mainBanner.value.href = href || ''
    mainBanner.value.linkText = linkText || ''
    mainBanner.value.type = type
    mainBanner.value.label = label
    mainBanner.value.show = true
  }

  const clearBanner = (label = null) => {
    if (label) {
      if (mainBanner.value.label !== label) return
    }
    
    // Clear any banner by calling without a label if necessary
    mainBanner.value = defaultBanner()
  }


  return {
    // STATE
    mainBanner,
    addBanner,
    clearBanner,

    // GETTERS

    // ACTIONS
  }
})
